import { adminApi, publicApi } from "@/lib/axios/instances";
import { ApiResponse } from "@/types/api";
import { Product, ProductsParams, ProductWithGroupDto } from "@/types/product";

export const fetchProducts = async (
  params?: ProductsParams,
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<ApiResponse<Product[]>> => {
  try {
    const response = await publicApi.get<ApiResponse<Product[]>>('/products', { params, ...config });
    return response.data;
  } catch (e) {
    console.error("products error", e);
    throw e;
  }
}

export const searchProducts = async (
  query: string,
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<Product[]> => {
  const { data } = await publicApi.get<ApiResponse<Product[]>>('/products', {
    params: { search: query },
    ...config,
  });

  return data.data;
}

export const fetchProductById = async (
  id: Product["id"],
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<Product> => {
  const { data } = await publicApi.get<Product>(`/products/${id}`, config);

  return data;
}

export const updateProduct = async (
  id: Product["id"],
  productData: Partial<Product>,
  files?: File[]
): Promise<Product> => {
  let payload: any;
  let headers: any = {};

  if (files && files.length > 0) {
    const formData = new FormData();
    Object.entries(productData).forEach(([key, value]) => {
      formData.append(key, value as any);
    });
    files.forEach(file => formData.append('images', file));
    payload = formData;
    headers['Content-Type'] = 'multipart/form-data';
  } else {
    payload = productData;
  }

  const { data } = await adminApi.patch<Product>(`/products/${id}`, payload, {
    headers,
  });

  return data;
}

export const updateMassProduct = async (
  ids: number[],
  productData: {
    hidden?: boolean;
  }
): Promise<Product[]> => {
  const { data } = await adminApi.patch<Product[]>(`/products/mass-update`, { ids, data: {...productData} });
  return data;
}

export const fetchProductWithGroup = async (
  id: Product["id"],
  config: Parameters<typeof publicApi.get>[1] = {}
): Promise<ProductWithGroupDto> => {
  const { data } = await publicApi.get<ProductWithGroupDto>(`/products/${id}/with-group`, config);
  return data;
}